import React, { useEffect, useState, useRef  } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { showToast } from './toastUtils';
import 'react-toastify/dist/ReactToastify.css';
import './Login.css'; // Add your styles here
import bimage from "./img/bimage.png";
import autodesk from "./img/autodesk.png";
import { queuedApiFetch, apiFetch } from './api';

function Login({ onLoginSuccess }) {
  const [searchParams] = useSearchParams();
  const getID = searchParams.get('id');
  const id = searchParams.get('id');
  const code = searchParams.get('code');
  //console.log('the code is :', code);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [step, setStep] = useState(1); // Step 1: Email, Step 2: Password
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const isSubmitting = useRef(false);

  //older code

  // useEffect(()=>{
  //   if(getID){
  //     handleLogin()
  //   }
  // },[getID])


  useEffect(() => {
    //setCookie();
    validateLogin();
  }, []);

  // const setCookie = async () => {
  //   const token = searchParams.get("accesscode");

  //   if (token) {
  //     fetch(process.env.REACT_APP_BACKEND_URL + "/autodesk/set-cookie", {
  //       method: "POST",
  //       credentials: "include",
  //       headers: {
  //         "Content-Type": "application/json"
  //       },
  //       body: JSON.stringify({ token })
  //     }).then(() => {
  //       //window.location.href = "/";
  //     });
  //   }
  // };

  const validateLogin = async () => {
    if (!id || !code) return;

    const formattedData = {
      email_id: id,
      code: code,
    };

    const requestOptions = {
      method: 'POST',
      // headers: {
      //   'Content-Type': 'application/json',
      //   // 'ngrok-skip-browser-warning': '69420',
      // },
      body: JSON.stringify(formattedData),
    };

    try {
      const result = await queuedApiFetch(`/user/login_validate`, requestOptions);
      const statusCode = result?.apistatus?.Status_Code ?? result?.apistatus?.status_Code;
      const statusDesc = result?.apistatus?.Status_Description ?? result?.apistatus?.status_Description;
      if (
        statusCode === 200 &&
        statusDesc?.toLowerCase() === 'success'
      ) {
        handleLogin();
      } else {
        console.warn('Login validation rejected:', result);
        showToast.error('Something went wrong. Please try again later');
      }
    } catch (error) {
      console.error('API error in validateLogin:', error);
    } finally {
    }
  };



  
  //newer code
  // useEffect(() => {
  //   if (getID) {
  //     const isLoggedIn = localStorage.getItem('isLoggedIn');
  //     const hostname = window.location.hostname;
  //     if (isLoggedIn) {
  //       handleLogin();
  //     }
  //   }
  // }, [getID]);
    
  

  const handleNext = (event) => {
    event.preventDefault();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      // alert('Please enter a valid email address.');
      showToast.error('Please enter a valid email address.');
      return;
    }

    // if (email.toLowerCase().includes('@nus')) {
    //   // Redirect if email contains @nus
    //   window.location.href = "https://nus.vmwareidentity.asia/SAAS/auth/federation/sso";
    //   return;
    // }

    if (email.toLowerCase().includes('@nus') || email.toLowerCase().includes('.nus')) {
      // Redirect if email contains @nus
      window.location.href = "https://nus.vmwareidentity.asia/SAAS/auth/federation/sso?redirecturl="+process.env.REACT_APP_BACKEND_URL;
      return;
    }

    // Proceed to the next step if the email is valid and does not contain @nus
    setStep(2);
  };

  // const handleLogin = (event) => {
  //   if (!loading) {
  //     setLoading(true);
  //     event.preventDefault();
  //     const requestOptions = {
  //       method: 'GET',
  //       //headers: new Headers({ 'ngrok-skip-browser-warning': '69420' })
  //     };
  //     queuedApiFetch('/user/checkuser?emailid=' + email, requestOptions)
  //       .then((response) => response.json())
  //       .then((data) => {
  //         if (data.apistatus.Status_Code === 200 && data.apistatus.Status_Description.toLowerCase() === 'success') {
  //           localStorage.setItem('accountId', data.data.bim360_account_id);
  //           localStorage.setItem('userEmail', email);
  //           localStorage.setItem('userDetails', JSON.stringify(data.data));
  //           onLoginSuccess();
  //           navigate('/homeacc');
  //           setLoading(false);
  //         } else {
  //           // alert('Invalid User');
  //           showToast.error('Invalid User');
  //         }
  //       })
  //       .catch((error) => console.error('Error fetching data:', error))
  //       .finally(() => setLoading(false));
  //   }
  // };

  const handleLogin1 = async (event) => {
    event.preventDefault();

    // 🚫 Prevent multiple calls
    if (isSubmitting.current) return;

    isSubmitting.current = true;
    setLoading(true);

    try {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (!emailRegex.test(email)) {
        showToast.error('Please enter a valid email address.');
        return;
      }

      const BASE_URL = process.env.REACT_APP_BACKEND_URL;
      const path = `/user/check_devuser?emailid=${encodeURIComponent(email)}`;
      const url = `${BASE_URL}${path}`;

      // const response = await fetch(url, {
      //   method: "GET"
      // });

      // const data = await response.json();

      const requestOptions = {
        method: 'GET',       
      };

      const response = await queuedApiFetch(`/user/checkuser?emailid=${encodeURIComponent(email)}`, //email
          requestOptions
        );
        const data = await response;

      if (
        data.apistatus.Status_Code === 200 &&
        data.apistatus.Status_Description.toLowerCase() === 'success'
      ) {
        localStorage.setItem('accountId', data.data.bim360_account_id);
        localStorage.setItem('userEmail', email);
        localStorage.setItem('userDetails', JSON.stringify(data.data));

        onLoginSuccess();
        localStorage.setItem('lastActiveRoute', '/homeacc');
        navigate('/homeacc');
      } else {
        showToast.error('Invalid User');
      }

    } catch (error) {
      console.error('Error fetching data:', error);
      showToast.error('Server error');
    } finally {
      setLoading(false);
      isSubmitting.current = false; // ✅ release lock
    }
  };


  const handleLogin = async () => { 
    if (!loading) {
      setLoading(true);
      // event.preventDefault();
  
      const requestOptions = {
        method: 'GET',
        //headers: new Headers({ 'ngrok-skip-browser-warning': '69420' }),
      };
  
      try {
        const response = await queuedApiFetch(`/user/checkuser?emailid=${getID}`, //email
          requestOptions
        );
        const data = await response;
        const statusCode = data?.apistatus?.Status_Code ?? data?.apistatus?.status_Code;
        const statusDesc = data?.apistatus?.Status_Description ?? data?.apistatus?.status_Description;
  
        if (statusCode === 200 && statusDesc?.toLowerCase() === 'success') {
          const userData = data.data || {};
          localStorage.setItem('accountId', userData.bim360_account_id);
          localStorage.setItem('userEmail', getID);         
          localStorage.setItem('userDetails', JSON.stringify(userData));
          onLoginSuccess();
          localStorage.setItem('lastActiveRoute', '/homeacc');
          navigate('/homeacc');
        } else {
          console.warn('Checkuser failed:', data);
          showToast.error('Invalid User');
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    }
  };

  


  return (
    <div className="login-container">
      <ToastContainer />
      <div className="login-content">
        <div style={{ display: 'flex', justifyContent: 'center', width: '100%', margin: '20px 0' }}>
          <button disabled={loading ? true : false} onClick={()=>{ window.location.href = process.env.REACT_APP_BACKEND_URL+'/autodesk/signin'}} type="button" style={{width : '200px'}} className="login-button">{loading ? 'Loading...' : 'Login Via Autodesk'}</button> 
        </div>
        
        {/* <button
          disabled={loading}
          onClick={() => {
            const fullHost = window.location.host;
            const subdomain = fullHost.includes('-') ? fullHost.split('-')[0] : '';
            console.log('Subdomain:', subdomain);
            const baseUrl = process.env.REACT_APP_BACKEND_URL + '/autodesk/signin';
            const finalUrl = subdomain
              ? `${baseUrl}?host=${encodeURIComponent(subdomain)}`
              : baseUrl;

            window.location.href = finalUrl;
          }}
          type="submit"
          style={{ width: '20%' }}
          className="login-button"
        >
          {loading ? 'Loading...' : 'Login Via Autodesk'}
        </button> */}

        <div className="footerlogo">
          <div className="footerlogogroup">
            Developed and Maintained by
            <img src={bimage} alt="BIMAGE" />
          </div>
          <div className="footerlogogroup">
            Powered by
            <img src={autodesk} alt="Autodesk" />
          </div>
        </div>
      </div>

      <div className="copyright">
        © 2024 BIMAGE Consulting. All rights reserved.
      </div>
    </div>
  );
}

export default Login;
